// extracted by mini-css-extract-plugin
export default {"dimmed":"dimmed__lginf"};